import React from "react";
import Select from "react-select";
import { AsyncPaginate } from "react-select-async-paginate";
import DatePicker from "react-datepicker";
import { LuRefreshCcw } from "react-icons/lu";
import { loadAccountHccIdentificationNumber } from "../../../utils/optionLoaderUtils";

const STATUS_OPTIONS = [
    { value: "in-review", label: "In Review" },
    { value: "accepted", label: "Accepted" },
    { value: "rejected", label: "Rejected" },
];

const InvoiceReviewFilters = ({ filters, setFilters, onApply, onClear, onRefresh, isRefreshing }) => {
    const selectedStatus = STATUS_OPTIONS.find((o) => o.value === filters.status) ?? null;

    const handleApply = () => onApply(filters);
    const handleClear = () => onClear();

    return (
        <div className="invoice-review-filters">
            <div className="invoice-review-filters__field invoice-review-filters__field--account">
                <label className="invoice-review-filters__label">Account</label>
                <AsyncPaginate
                    loadOptions={loadAccountHccIdentificationNumber}
                    value={filters.accounts ?? []}
                    onChange={(opts) =>
                        setFilters((prev) => ({
                            ...prev,
                            accounts: opts ?? [],
                        }))
                    }
                    isMulti
                    isClearable
                    placeholder="Search accounts..."
                    debounceTimeout={300}
                    classNamePrefix="invoice-select"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
            </div>

            <div className="invoice-review-filters__field invoice-review-filters__field--status">
                <label className="invoice-review-filters__label">Status</label>
                <Select
                    options={STATUS_OPTIONS}
                    value={selectedStatus}
                    onChange={(selected) =>
                        setFilters((prev) => ({ ...prev, status: selected?.value ?? null }))
                    }
                    isClearable
                    placeholder="All statuses"
                    classNamePrefix="invoice-select"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
            </div>

            <div className="invoice-review-filters__field invoice-review-filters__field--date">
                <label className="invoice-review-filters__label">Run Date</label>
                <div className="invoice-review-filters__date-range">
                    <DatePicker
                        selected={filters.dateFrom ? new Date(filters.dateFrom) : null}
                        onChange={(date) =>
                            setFilters((prev) => ({
                                ...prev,
                                dateFrom: date ? date.toISOString().slice(0, 10) : null,
                                dateTo: date && prev.dateTo && date > new Date(prev.dateTo) ? null : prev.dateTo,
                            }))
                        }
                        placeholderText="Start date"
                        dateFormat="yyyy-MM-dd"
                        isClearable
                        selectsStart
                        startDate={filters.dateFrom ? new Date(filters.dateFrom) : null}
                        endDate={filters.dateTo ? new Date(filters.dateTo) : null}
                        className="date-picker"
                        wrapperClassName="date-picker-wrapper"
                        portalId="root"
                    />
                    <span className="invoice-review-filters__date-sep" aria-hidden="true">—</span>
                    <DatePicker
                        selected={filters.dateTo ? new Date(filters.dateTo) : null}
                        onChange={(date) =>
                            setFilters((prev) => ({
                                ...prev,
                                dateTo: date ? date.toISOString().slice(0, 10) : null,
                            }))
                        }
                        placeholderText="End date"
                        dateFormat="yyyy-MM-dd"
                        isClearable
                        selectsEnd
                        startDate={filters.dateFrom ? new Date(filters.dateFrom) : null}
                        endDate={filters.dateTo ? new Date(filters.dateTo) : null}
                        minDate={filters.dateFrom ? new Date(filters.dateFrom) : undefined}
                        className="date-picker"
                        wrapperClassName="date-picker-wrapper"
                        portalId="root"
                    />
                </div>
            </div>

            <div className="invoice-review-filters__actions">
                <button
                    type="button"
                    className="invoice-review-filters__btn invoice-review-filters__btn--apply"
                    onClick={handleApply}
                >
                    Apply
                </button>
                <button
                    type="button"
                    className="invoice-review-filters__btn invoice-review-filters__btn--clear"
                    onClick={handleClear}
                >
                    Clear
                </button>
                <button
                    type="button"
                    className="invoice-review-filters__btn invoice-review-filters__btn--refresh"
                    onClick={onRefresh}
                    disabled={isRefreshing}
                    aria-label="Refresh list"
                    title="Refresh list"
                >
                    <LuRefreshCcw
                        size={15}
                        className={isRefreshing ? "invoice-review-filters__refresh-icon--spinning" : ""}
                    />
                </button>
            </div>
        </div>
    );
};

export default InvoiceReviewFilters;
